import { useMemo } from 'react';
import {
  type FormHeaderFooterExit,
  type FormHeaderFooterProviderExit,
  isAnchorExit,
  isButtonExit,
  isDefault,
  isLinkExit,
} from './types';

export type NavigateToPathname = (pathname: string, state?: unknown) => void;

interface UseResolveExitConfigArgs {
  exit: FormHeaderFooterExit;
  isProd: boolean;
  navigate: NavigateToPathname;
  defaultExitPath?: string;
}
export function useResolveExitConfig({
  exit,
  isProd,
  navigate,
  defaultExitPath = '/bank',
}: UseResolveExitConfigArgs): FormHeaderFooterProviderExit | null {
  return useMemo(() => {
    const label = exit.label;
    const origin = isProd
      ? 'https://www.storebrand.no'
      : 'https://www-t.storebrand.no';
    if (isDefault(exit)) {
      const url = new URL(defaultExitPath, origin).href;
      return {
        element: 'a',
        label,
        onExitEvent: (e) => {
          e.detail.originalEvent.preventDefault();
          exit.onClick?.(e);
          globalThis.location.assign(url);
        },
        url,
      };
    }
    if (isLinkExit(exit)) {
      return {
        element: 'a',
        label,
        onExitEvent: (e) => {
          e.detail.originalEvent.preventDefault();
          exit.onClick?.(e);
          navigate(exit.pathname, exit.state);
        },
        url: new URL(exit.pathname, origin).href,
      };
    }
    if (isAnchorExit(exit)) {
      const url = new URL(exit.href, origin).href;
      return {
        element: 'a',
        label,
        onExitEvent: (e) => {
          e.detail.originalEvent.preventDefault();
          exit.onClick?.(e);
          globalThis.location.href = url;
        },
        url,
      };
    }
    if (isButtonExit(exit)) {
      return {
        element: 'button',
        label,
        onExitEvent: (e) => {
          exit.onClick(e);
          e.detail.originalEvent.preventDefault();
        },
      };
    }
    return null;
  }, [exit, isProd, navigate, defaultExitPath]);
}
